import React from "react";
import { Link } from "react-router-dom";
import { Twitter, Instagram, Facebook, Radio } from "lucide-react";
import { STATION, SOCIALS } from "../mock";

const ICONS = { Twitter, Instagram, Facebook };

const Footer = () => {
  return (
    <footer className="relative overflow-hidden bg-[#1E5FD0]">
      <div className="absolute -top-32 left-1/2 h-64 w-[42rem] -translate-x-1/2 rounded-full bg-white/15 blur-3xl" />
      <div className="relative mx-auto max-w-6xl px-5 sm:px-8 py-16">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-[#1E6BE6] to-[#2E7DF7] shadow-lg shadow-blue-900/20 ring-1 ring-white/30">
                <img src={STATION.logo} alt="All-In Radio" className="h-full w-full object-contain p-2" />
              </span>
              <span className="font-heading text-lg font-extrabold text-white">All-In Radio</span>
            </div>
            {STATION.slogan ? (
              <p className="mt-4 max-w-xs text-sm text-blue-100">{STATION.slogan}</p>
            ) : null}
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-blue-200">Navigatie</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/" className="text-blue-50 hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/geschiedenis" className="text-blue-50 hover:text-white transition-colors">Geschiedenis</Link></li>
              <li><Link to="/luisterlinks" className="text-blue-50 hover:text-white transition-colors">Luisterlinks</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-blue-200">Volg ons</h4>
            <div className="mt-4 flex gap-3">
              {SOCIALS.map((s) => {
                const Icon = ICONS[s.icon] || Radio;
                return (
                  <a key={s.id} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.name} className="flex h-10 w-10 items-center justify-center rounded-full border border-white/20 bg-white/10 text-white transition-all hover:bg-white hover:text-[#1E6BE6]">
                    <Icon className="h-5 w-5" />
                  </a>
                );
              })}
            </div>
            <div className="mt-6 inline-flex items-center gap-2 rounded-lg border border-white/20 bg-white/10 px-3 py-2 text-xs text-blue-50">
              <span className="font-semibold text-white">Buma/Stemra · Sena</span>
              <span className="text-blue-200">#{STATION.license}</span>
            </div>
          </div>
        </div>

        <div className="mt-12 border-t border-white/15 pt-6 text-center text-sm text-blue-100">
          © {new Date().getFullYear()} All-In Radio. Alle rechten voorbehouden.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
